module.exports = __webpack_public_path__ + "static/media/kreistsWhite.3f85b66e.svg";